import React from "react";
import { IconType } from "../../type/icon_type";

interface IconInfoProps extends IconType {
  color?: string;
  style?: React.CSSProperties;
  onClick?: () => void;
}

const IconInfo = ({
  width,
  height,
  color = "#73787E",
  fill,
  style,
  onClick,
}: IconInfoProps) => {
  return (
    <svg
      width={width || "18px"}
      height={height || "18px"}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9 12V9M9 6H9.0075M16.5 9C16.5 13.1421 13.1421 16.5 9 16.5C4.85786 16.5 1.5 13.1421 1.5 9C1.5 4.85786 4.85786 1.5 9 1.5C13.1421 1.5 16.5 4.85786 16.5 9Z"
        stroke={color}
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default IconInfo;
